import { FC } from 'react';

import styled from '@emotion/styled';
import { Stack, SxProps, Typography, useTheme } from '@mui/material';
import { getAccentColor } from 'portfolio3/styles';

import { content } from './styles';

interface IConclusionsProps {
  title: string;
  viewYourWork: () => void;
  text?: string;
  url?: string;
}

// const Button = styled('button')<IStyledButtonProps>(() => ({
//   fontSize: '14px',
//   lineHeight: '20px',
//   fontWeight: 600,
//   color: getAccentColor('indigo', '200'),
//   width: 'max-content',
//   padding: 0,
//   border: 'none',
//   backgroundColor: 'unset',

//   '&:hover': {
//     cursor: 'pointer',
//   },
// }));

const StyledLink = styled.a`
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  color: #3d5de0;
  cursor: pointer;
  font-family: 'Inter';
  line-height: 20px;

  &:hover {
    text-decoration: underline;
  }
`;

const Conclusions: FC<IConclusionsProps> = ({ title, text, url, viewYourWork }) => {
  const theme = useTheme();
  // const [isMaxHeightContent, setIsMaxHeightContent] = useState(false);
  // const handleSetMaxHeight = () => setIsMaxHeightContent(true);
  const wrapperSx: SxProps = {
    backgroundColor: getAccentColor(theme.palette.accentColor, '8'),
    padding: '12px 16px',
    borderRadius: '8px',
  };
  return (
    <Stack gap="8px" sx={wrapperSx}>
      <Typography variant="Paragraph MD/Semi Bold">{title}</Typography>
      <Typography variant="Paragraph MD/Regular" sx={content}>
        {text}
      </Typography>
      {/* TODO вернуть когда придет время и сделать нормальное скрытие раскрытие тексти,
          и скрывать кнопку если текст раскрыт полностью */}
      {/* <Button onClick={handleSetMaxHeight}>Подробнее</Button> */}
      {url && (
        <StyledLink href={url} rel="noreferrer" target="_blank" onClick={viewYourWork}>
          Посмотреть свою работу
        </StyledLink>
      )}
    </Stack>
  );
};

export default Conclusions;
